export default angular.module('ApiUtils.lab.external.pepsiCo.storageNet', []);